import { createDragDropManager } from "dnd-core";
import type { PropsWithChildren } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
const globalManager = createDragDropManager(HTML5Backend);

const GlobalDndProvider = ({ children }: PropsWithChildren) => {
  return <DndProvider manager={globalManager}>{children}</DndProvider>;
};

export default GlobalDndProvider;
